import { app, Component, ojs, v } from "modular-openscriptjs";
import { pageInfo, scrollToTop, empty, searchPlaceholder, eParse } from "../../helpers";
import { PAGES, dc } from "../../declarations";

import SearchBar from "../Blocks/SearchBar";
import SearchDefault from "./Search/SearchDefault";
import SearchResults from "./Search/SearchResults";
import AlgoliaSearch from "../../classes/AlgoliaSearch";

const h = app("h");

ojs(SearchDefault, SearchResults);

export default class SearchPage extends Component {
    $$app = {
        has: {
            searchCharacter: async (ed, event) => {
                const { message } = eParse(ed);
                let query = message.get("value");

                if (empty(query)) {
                    dc.searchSuggestions.value = [];
                    return;
                }

                /**
                 * @type {AlgoliaSearch}
                 */
                let client = app("AlgoliaSearch");

                let result = await client.getSuggestions(query);
                dc.searchSuggestions.value = result;
            },
        },
    };

    
    render(...args) {
        pageInfo(PAGES.SEARCH);
        scrollToTop();
        searchPlaceholder("Find anything...");

        return h.div(
            v(dc.searchQuery, (queryState) => {
                const query = queryState.value;
                if (empty(query)) {
                    return h.SearchDefault();
                } else {
                    return h.SearchResults();
                }
            }),
            ...args,
        );
    }
}

ojs(SearchPage);
